import { render, staticRenderFns } from "./TabbarIndex.vue?vue&type=template&id=4f880ec4&scoped=true"
import script from "./TabbarIndex.vue?vue&type=script&lang=js"
export * from "./TabbarIndex.vue?vue&type=script&lang=js"
import style0 from "./TabbarIndex.vue?vue&type=style&index=0&id=4f880ec4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f880ec4",
  null
  
)

export default component.exports